import axios from "axios";

import type {
  ApiResponse,
  TipoActividadDto,
  CreateTipoActividadDto,
  EventoCalendarioDto,
  CreateEventoCalendarioDto,
  UpdateEventoCalendarioDto,
} from "../../app/admin-colegio/calendario/dto/calendarios.dto";


const API_WEB_URL = process.env.REACT_APP_API_WEB_URL;

if (!API_WEB_URL) {
  throw new Error("REACT_APP_API_WEB_URL no está definida");
}

const calendarioApi = axios.create({
  baseURL: `${API_WEB_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

calendarioApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

class AdminColegioCalendarioService {
  async getTiposActividad(): Promise<TipoActividadDto[]> {
    const res = await calendarioApi.get<ApiResponse<TipoActividadDto[]>>(
      "/admin-colegio/calendario/tipos-actividad"
    );
    return res.data.data;
  }

  async createTipoActividad(
    payload: CreateTipoActividadDto
  ): Promise<TipoActividadDto> {
    const res = await calendarioApi.post<ApiResponse<TipoActividadDto>>(
      "/admin-colegio/calendario/tipos-actividad",
      payload
    );
    return res.data.data;
  }

  async getEventos(
    mes: number,
    anio: number,
    cursoId?: number
  ): Promise<EventoCalendarioDto[]> {
    const params = new URLSearchParams({
      mes: mes.toString(),
      anio: anio.toString(),
    });

    if (cursoId !== undefined) {
      params.append("cursoId", cursoId.toString());
    }

    const res = await calendarioApi.get<ApiResponse<EventoCalendarioDto[]>>(
      `/admin-colegio/calendario/eventos?${params.toString()}`
    );

    return res.data.data;
  }

  async createEvento(
    payload: CreateEventoCalendarioDto
  ): Promise<EventoCalendarioDto> {
    const res = await calendarioApi.post<ApiResponse<EventoCalendarioDto>>(
      "/admin-colegio/calendario/eventos",
      payload
    );
    return res.data.data;
  }

  async updateEvento(
    idEvento: number,
    payload: UpdateEventoCalendarioDto
  ): Promise<EventoCalendarioDto> {
    const res = await calendarioApi.put<ApiResponse<EventoCalendarioDto>>(
      `/admin-colegio/calendario/eventos/${idEvento}`,
      payload
    );
    return res.data.data;
  }

  async deleteEvento(idEvento: number): Promise<void> {
    await calendarioApi.delete(`/admin-colegio/calendario/eventos/${idEvento}`);
  }
}

export const adminColegioCalendarioService =
  new AdminColegioCalendarioService();
